export default "__VITE_ASSET__0ed4eca3__"